import VideoCard from "./video-card";

export { VideoCard };
